/**
 * AI文本管理器
 *
 * 负责:
 * 1. 接收AI流
 * 2. 保存全文
 * 3. 切句
 * 4. 推入语音队列
 */

import SentenceSplitter from "./SentenceSplitter";

export default class TextManager {
    constructor(options = {}) {
        this.fullText = "";
        this.splitter = new SentenceSplitter(options);
        this.onSentence = null;
    }

    /**
     * 添加AI流文本
     *
     * @param text AI返回chunk
     */
    append(text){
        try{
            if(!text){
                return;
            }

            // 防重复追加：如果 fullText 末尾已存在相同文本，跳过
            // 避免外部在 play 前重复调用 appendText 导致全文累积
            if (this.fullText) {
                const tailLen = Math.min(text.length, this.fullText.length);
                const tail = this.fullText.slice(-tailLen);
                if (tail === text) {
                    return;
                }
            }

            this.fullText += text;
            const sentences= this.splitter.append(text);

            sentences.forEach(item=>{
                const value=item?.trim();
                if(value){
                    this.onSentence?.(value);
                }
            });
        }catch(e){
            console.error("[TextManager.append error]", e);
        }
    }

    /**
     * AI结束
     *
     * 处理最后没有标点的文本
     */
    finish() {
        const sentences = this.splitter.flush();

        sentences.forEach(item => {
            this.onSentence?.(item);
        });
    }

    /**
     * 获取完整文本
     */
    getText() {
        return this.fullText;
    }

    /**
     * 重新播放需要
     *
     * 根据全文重新切句
     */
    rebuild() {
        const text = this.fullText;

        if (!text) {
            return;
        }

        this.splitter.clear();
        const sentences = [
            ...this.splitter.append(text),
            ...this.splitter.flush()
        ];

        sentences.forEach(item => {
            const value = item?.trim();
            if (value) {
                this.onSentence?.(value);
            }
        });
    }

    /**
     * 清空
     */
    clear() {
        this.fullText = "";
        this.splitter.clear();
    }
}
